var _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 60,
    x2: 75,
    y2: 35,
    stroke: "black",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 60,
    x2: 25,
    y2: 35,
    stroke: "black",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 75,
    x2: 75,
    y2: 50,
    stroke: "black",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 75,
    x2: 25,
    y2: 50,
    stroke: "black",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.90b4b5516b61073bf6e5ab4c2196733f.svg";
export { ForwardRef as ReactComponent };